import { TAGS } from "../constants";
import { OnlineVisit, OnlineVisitCreate, VisitType } from "../types";
import { api } from "./api";

export const onlineVisitsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getPatientVisits: builder.query<
      OnlineVisit[],
      { patientId: number; sort?: boolean }
    >({
      query: ({ patientId, ...params }) => ({
        method: "GET",
        url: `/api/visits/patient/${patientId}`,
        params,
      }),
      providesTags: (_returns, _error, args) => [
        { type: TAGS.ONLINE_VISITS, id: args.patientId },
      ],
    }),
    getPatientVisit: builder.query<OnlineVisit, number>({
      query: (id) => ({
        method: "GET",
        url: `/api/visits/${id}`,
      }),
      providesTags: (_returns, _error, arg) => [
        { type: TAGS.ONLINE_VISITS, id: arg },
      ],
    }),
    updatePatientVisit: builder.mutation<
      OnlineVisit,
      { id: number; patient_id: number; body: Partial<OnlineVisit> }
    >({
      query: ({ id, body }) => ({
        method: "PUT",
        url: `/api/visits/${id}`,
        body,
      }),
      onQueryStarted: async (args, { dispatch, queryFulfilled }) => {
        const { data } = await queryFulfilled;

        dispatch(
          onlineVisitsApi.util.updateQueryData(
            "getPatientVisits",
            { patientId: args.patient_id, sort: true },
            (draft) => {
              for (let i = 0; i < draft.length; i++) {
                if (draft[i].id === args.id) {
                  draft[i] = data;
                  break;
                }
              }
            },
          ),
        );
      },
    }),
    getPatientVisitByVisitType: builder.query<
      OnlineVisit,
      {
        patient_id: number;
        product_slug: string;
        status?: string;
        visit_type?: VisitType;
        ascending?: string;
      }
    >({
      query: ({ patient_id, visit_type, product_slug, status, ascending }) => ({
        method: "GET",
        url: `/api/visits/${visit_type}/patient/${patient_id}`,
        params: { product_slug, status, ascending },
      }),
      providesTags: (_returns, _error, args) => [
        { type: TAGS.ONLINE_VISIT, id: args.patient_id },
      ],
    }),
    generatePatientVisitUrl: builder.mutation<string, OnlineVisitCreate>({
      query: (body) => ({
        method: "POST",
        url: `/api/visits/link`,
        responseHandler: "text",
        body,
      }),
      invalidatesTags: [TAGS.ONLINE_VISITS],
    }),
  }),
});

export const {
  useGetPatientVisitsQuery,
  useUpdatePatientVisitMutation,
  useGetPatientVisitByVisitTypeQuery,
  useGetPatientVisitQuery,
  useGeneratePatientVisitUrlMutation,
} = onlineVisitsApi;
